import { useState, useEffect } from 'react';

export const useUserData = () => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkUserData = () => {
      const clienteNome = localStorage.getItem('clienteNome');
      const unidadeConsumidoraId = localStorage.getItem('unidadeConsumidoraId');

      console.log('User data check:', { clienteNome, unidadeConsumidoraId });

      setUser({
        clienteNome: clienteNome || '',
        unidadeConsumidoraId: unidadeConsumidoraId || ''
      });
      setIsLoading(false);
    };

    // Executa imediatamente
    checkUserData();

    // Também executa após um pequeno delay para capturar dados que podem ser setados após o primeiro render
    const timeoutId = setTimeout(checkUserData, 500);

    return () => clearTimeout(timeoutId);
  }, []);

  return { user, isLoading };
};
